interface doItEN {
  title_section: string;
  we_are_title: string;
  we_are_desc_1_1: string;
  we_are_desc_1_2: string;
  our_mission_title: string;
  our_mission_desc: string;
  our_vision_title: string;
  our_vision_desc: string;
}

export const doItEN: doItEN = {
  title_section: "DO IT RIGHT. DO IT FAST. DO IT.",
  we_are_title: "WE ARE",
  we_are_desc_1_1:
    "A boutique consulting firm specializing in customized transformation initiatives based on Lean principles. We call this approach ",
  we_are_desc_1_2: "Impetus.",
  our_mission_title: "OUR MISSION",
  our_mission_desc:
    "We serve as a key partner in embedding an Operational Excellence mindset and habits into our clients’ daily practices.",
  our_vision_title: "OUR VISION",
  our_vision_desc:
    "To be the strategic ally our clients rely on to identify, develop, and enhance their value—within their industry and beyond.",
};

interface ourValuesEN {
  title_section: string;
  respect: string;
  respect_desc: string;
  self_control: string;
  self_control_desc: string;
  wisdom: string;
  wisdom_desc: string;
  responsibility: string;
  responsibility_desc: string;
  honesty: string;
  honesty_desc: string;
}

export const ourValuesEN: ourValuesEN = {
  title_section: "OUR VALUES",
  respect: "Respect:",
  respect_desc:
    "We honor the dignity, context, merit, and values of each customer.",
  self_control: "Self-control:",
  self_control_desc:
    "We believe in the importance of managing our impulses and emotions with integrity.",
  wisdom: "Wisdom:",
  wisdom_desc:
    "We apply our knowledge and experience to help improve society through meaningful activities.",
  responsibility: "Responsibility:",
  responsibility_desc:
    "We take ownership of our actions and are accountable for their outcomes.",
  honesty: "Honesty:",
  honesty_desc:
    "We uphold the virtues of sincerity, dignity, trust, and confidence.",
};

interface ourStoryEN {
  title_section: string;
  card_2016_year: string;
  card_2016_title: string;
  card_2016_desc_1_1: string;
  card_2016_desc_1_2: string;
  card_2017_year: string;
  card_2017_desc_1_1: string;
  card_2017_desc_1_2: string;
  card_2017_desc_1_3: string;
  card_2017_desc_1_4: string;
  card_2017_desc_2_1: string;
  card_2017_desc_2_2: string;
  card_2017_desc_2_3: string;
  card_2017_desc_2_4: string;
  card_2017_desc_3: string;
  card_2017_desc_4_1: string;
  card_2017_desc_4_2: string;
  card_2017_desc_4_3: string;
  card_2018_year: string;
  card_2018_title: string;
  card_2018_desc_1_1: string;
  card_2018_desc_1_2: string;
  card_2019_year: string;
  card_2019_desc_1_1: string;
  card_2019_desc_1_2: string;
  card_2019_desc_1_3: string;
  card_2019_desc_1_4: string;
  card_2019_desc_1_5: string;

  card_2024_year: string;
  card_2024_title: string;
  card_2024_desc_1_1: string;
  card_2024_desc_1_2: string;
  card_2024_desc_1_3: string;
  card_2024_desc_1_4: string;
  card_2024_desc_1_5: string;
  card_2024_desc_1_6: string;
  card_2024_desc_1_7: string;
  image_mx: string;
  image_us: string;
}

export const ourStoryEN: ourStoryEN = {
  title_section: "OUR STORY",
  card_2016_year: "2016",
  card_2016_title: "GBCI Group begins operations.",
  card_2016_desc_1_1:
    "We identified several options for deploying Operational Excellence and chose to call it ",
  card_2016_desc_1_2: "“Impetus.”",
  card_2017_year: "2017",
  card_2017_desc_1_1: "We introduced ",
  card_2017_desc_1_2: "Impetus",
  card_2017_desc_1_3: ", which includes:",
  card_2017_desc_1_4:
    "Continuous Improvement, Daily Management, Innovation, Transformation, and Process Automation.",

  card_2017_desc_2_1: "GBCI Group launched the ",
  card_2017_desc_2_2: "Impetus Selection Assessment",
  card_2017_desc_2_3: ", formerly known as the",
  card_2017_desc_2_4: "Operational Excellence Journey Selection Tool.",

  card_2017_desc_3: "Are you curious about how to choose the right Impetus?",

  card_2017_desc_4_1: "In addition to client support, we now offer ",
  card_2017_desc_4_2: "executive coaching ",
  card_2017_desc_4_3: "as an official service.",

  card_2018_year: "2018",
  card_2018_title: "GBCI Group expanded",
  card_2018_desc_1_1: "We participated in the ",
  card_2018_desc_1_2: "North America Executive Committee Lean Training.",

  card_2019_year: "2019",
  card_2019_desc_1_1: "During the ",
  card_2019_desc_1_2: "COVID-19 pandemic",
  card_2019_desc_1_3: ", we leveraged our ",
  card_2019_desc_1_4: "Impetus for Process Automation ",
  card_2019_desc_1_5:
    "to help clients successfully transition to digital operations.",

  card_2024_year: "2024",
  card_2024_title: "Office Opening in Mexico.",
  card_2024_desc_1_1: "We began developing our ",
  card_2024_desc_1_2: "Continuous Improvement ",
  card_2024_desc_1_3: "platform through the ",
  card_2024_desc_1_4: "Impetus App ",
  card_2024_desc_1_5: "and launched the ",
  card_2024_desc_1_6: "Digital Games Division ",
  card_2024_desc_1_7: "of GBCI Group.",

  image_mx: "Office in Tampico, Tamaulipas, MX",
  image_us: "Office in Houston, Texas, USA",
};
